export const PrizeSlugToEnterPage: Record<string, Record<string, string>> = {
  'win-a-cotswolds-luxury-weekend-spa-break': {
    known: '/enter?em=LiteSubscription&pc=BEAUTY1FREE',
  },
  'win-2k-credit-with-offpeakluxury': {
    offpeakluxury: '/enter?em=LiteSubscription&pc=OFFPEAK1FREE',
  },
  'south-africa': {
    luckytrip: '/enter?em=LiteSubscription&pc=LUCKYTRIP1FREE',
  },
  'win-a-mega-adventure-in-london-for-two-by-indytute': {
    indytute: '/enter?em=LiteSubscription&pc=INDY2LDN',
  },
  // Add more prizes and UTM sources as needed
};
